<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addPayment, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    modal-import(model="payment" :title="$t('front.import_modal', {model: $t('strings.payment')})")
    modal-payments(:newRecord='newRecord', :is-add='isModalAdd')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.payments') }}:
            span {{ $t('strings.description', {attribute: $t('strings.payments')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(v-model="selected"  max-height="350px" :data="payments")
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)"  width="300px")
                div
                  vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('payments.'+ item)")
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref='dropdown' vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                        vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                          vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                        //- Add filters
                            Agrega los filtros que prefieras por ejemplo:
                            vm-select.filter(url="customers" columns="tradename,etc" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('sales.customer_id')" v-model="filters.whereIn.customer_id" @input-change="autoCompleteFunc")
                              vm-select-item(:key="index" :value="item.id" :text="item.tradename" v-for="(item,index) in paymentsCatalog.customers")
                            vm-date-picker.filter(type="daterange" :label="$t('payments.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")

                            NOTA: (agregar clase .filter)
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('payments.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column == 'folio'")  {{data[indextr][column]}}
                  slot(v-if="column == 'user_id'")  {{data[indextr]['user']['name'] + ' ' + data[indextr]['user']['last_name']}}
                  slot(v-if="column == 'status'")  {{data[indextr]['status_display']}}
                  slot(v-if="column == 'conekta_commission'")  {{data[indextr]['conekta_commission'] | currency }}
                  slot(v-if="column == 'amount'")  {{data[indextr]['amount'] | currency }}
                  slot(v-if="column == 'date'")  {{data[indextr]['created_at']}}
                vm-td
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ModalPayments from '@/components/modals/ModalPayments.vue'
import ModalImport from '@/components/modals/ModalImport.vue'
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Payments')

export default {
  name: 'Payments',
  components: {
    ModalPayments,
    ModalImport
  },
  data: () => ({
    currentPage: 1,
    isModalAdd: true,
    newRecord: {},
    selected: [],
    columns: [
      'folio',
      'user_id',
      'status',
      'conekta_commission',
      'amount',
      'date'
    ],
    columnsOrderBy: [
      // Nota solo si las columnas son atributos
    ],
    status: [
      // Agregar los estatus si maneja
      {
        text: 'En proceso',
        value: 'inprogress',
        color: 'primary'
      },
      {
        text: 'Completado',
        value: 'completed',
        color: 'success'
      },
      {
        text: 'Fallido',
        value: 'failed',
        color: 'danger'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        // Agregar las columnas que se filtraran en el buscador
        folio: '',
        // name_last_name: [
        //  'name',
        //  'last_name'
        // ],
        user: {
          email: ''
        },
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
        status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  computed: {
    ...mapGetters([
      'payments',
      'pagination',
      'filterParams'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, $\{t.$t('payments.' + column)}` : `${str} ${t.$t('payments.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.payment'), columns: concatColumns, column: this.$t('payments.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getPayments(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getPayments(this.currentPage)
    }
  },
  async created () {
    this.filtersClear = parseVuexObject(this.filters)
    await this.getPayments(1)
    // await this.loadPaymentsCatalog()
  },
  methods: {
    ...mapActions([
      'deletePayment',
      'deletePayments',
      'loadPayments',
      'loadCatalog',
      'loadPaymentsCatalog',
      'actionPayment',
      'setModalImportVisible',
      'setModalVisible',
      'printReport',
      'applyFilter',
      'clearFilter'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === code)['color']
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    editShortcut () {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.payments.findIndex(u => u.id === this.selected[0].id)
      this.editPayment(this.selected[0], idx)
    },
    addPayment () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.newRecord = {}
    },
    editPayment (payment, index) {
      this.isModalAdd = false
      this.setModalVisible(true)
      this.newRecord = { ...payment }
    },
    async deletePaymentConfirm (payment) {
      let t = this
      this.auxDeletePayment = () => {
        t.deletePayment(payment).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.payment'), attribute: this.$t(payment.id) }),
        accept: this.auxDeletePayment
      })
    },
    async deletePaymentsConfirm () {
      let t = this
      let paymentsMany = parseDeleteMany(this.selected, 'id')
      this.auxDeletePayment = () => {
        t.deletePayments(paymentsMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.payment'), attribute: paymentsMany.values }),
        accept: this.auxDeletePayment
      })
    },
    async setActionPayment (record, action) {
      record.id && this.actionPayment({ id: record.id, action })
    },
    async getPayments (page) {
      let t = this
      this.loadPayments({ page }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let payment = this.payments.filter(payment => payment.id === parseInt(index))[0]
      payment && this.editPayment(payment, index)
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      // this.filters.betweenDates.created_at = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  float: left;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
